import Field, { FieldProps } from '../field/Field';
import React from 'react';

interface AlphaNumericFieldProps extends Omit<FieldProps, 'type' | 'onKeyPress'> {}

const AlphaNumericField = (props: AlphaNumericFieldProps) => (
  <Field
    type="text"
    onKeyPress={event => {
      const regex = /^[a-zA-Z0-9]+$/;

      if (!regex.test(event.key)) {
        event.preventDefault();
      }
    }}
    {...props}
  />
);

export default AlphaNumericField;
